import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import useRuntimeConfig from '@vl-core/useRuntimeConfig';
import { useQuery } from '@tanstack/react-query';

interface DocmanGPRejectedModalProps {
  user: {
    restricted: boolean | null;
    user_guid: string;
  } | null;
}

const MODAL_STORAGE_KEY = 'docman-patient-gp-rejected';

export const resetDocmanGPRejectedModal = () => {
  sessionStorage.removeItem(MODAL_STORAGE_KEY);
};

const DocmanGPRejectedModal = ({ user }: DocmanGPRejectedModalProps) => {
  const { t } = useTranslation('common');
  const { DOCMAN } = useRuntimeConfig();
  const dispatch = useDispatch();

  const { data: gpDetails } = useQuery({
    queryKey: ['getGPDetails', user?.user_guid],
    queryFn: () => {
      if (!user?.user_guid) {
        console.error('user_guid required');
        return null;
      }
      return dispatch(actions.getGpDetails(user.user_guid));
    },
    enabled: !!user
  });

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!user || !gpDetails) return;

    const hasSeenModal = !!sessionStorage.getItem(MODAL_STORAGE_KEY);

    if (!hasSeenModal && DOCMAN && !user?.restricted && gpDetails?.docman_invalid_gp) setIsOpen(true);
  }, [user, gpDetails]);

  const onClose = () => {
    setIsOpen(false);
    sessionStorage.setItem(MODAL_STORAGE_KEY, 'true');
  };

  const handleOnCancel = () => {
    onClose();
  };

  const handleOnOk = () => {
    onClose();
    window.location.assign([window.location.pathname, 'profile'].join('/'));
  };

  if (!isOpen) return null;

  return (
    <Modal
      closable
      centered
      title={t('Update your GP details')}
      okText={t('Update GP details')}
      open={isOpen}
      onOk={handleOnOk}
      onCancel={handleOnCancel}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <p>{gpDetails?.docman_rejection_desc}</p>
    </Modal>
  );
};

export default DocmanGPRejectedModal;
